module.exports = __webpack_public_path__ + "media/images/icons/SVG/068-e3e7ed78bf37cedc52599e23b9c16148.svg";